import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import _get from 'lodash/get';
import { replacePlaceholders } from 'utils/stringUtils';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles({
  wrapper: {
    backgroundColor: '#222222',
    padding: '15px 0',
  },
  text: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
    color: '#666666',
    fontFamily: 'OpenSansRegular',
    fontSize: 14,
    lineHeight: '1.7em',
  },
});

function Footer() {
  const classes = useStyles();
  const [footerSiteCopy] = useSiteCopySelector(['footer']);

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.text}>
        {replacePlaceholders(
          _get(footerSiteCopy, 'pageCopy.copyrightSentenceCorporate'),
          {
            '#currentYear': new Date().getFullYear(),
          },
        )}
      </Typography>
    </div>
  );
}

export default Footer;
